/**
 * @shoppy/i18n — bilingual MN/EN resources and the Cyrillic↔Latin
 * transliteration table.
 *
 * `mn-hunspell` is PINNED here, never tracked: bumping it is a deliberate,
 * scheduled reindex (docs/07-repo-layout.md, ADR-0009).
 */
export const locales = ["mn", "en"];
export const defaultLocale = "mn";
/**
 * The pinned `mn-hunspell` build that `docker/opensearch/hunspell/mn_MN/` must
 * contain. Bumping this is a deliberate, scheduled full reindex (ADR-0009):
 * the stemmer is part of the index mapping, not a runtime setting.
 * Source: /Users/xenon/Developer/mn-hunspell (no remote yet — see docs/23).
 */
export const mnHunspellPin = { commit: "d5dd69e", builtOn: "2026-06-02" };
export * from "./transliteration.js";
//# sourceMappingURL=index.js.map